<template>
  <div
    class="RoleFeatureGroup flex"
    :class="isActive ? 'active' : 'not-active'"
  >
    <h6>{{ title }}</h6>
    <div class="list">
      <RoleFeature
        v-for="feature in features"
        :active="permissionsList[feature]"
        :key="feature.name"
      >
        {{ $t("permission.bpz." + feature) }}
      </RoleFeature>
    </div>
  </div>
</template>
<script>
import RoleFeature from "./feature.vue";
export default {
  name: "RoleFeatureGroup",
  components: {
    RoleFeature,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    features: {
      type: Array,
      default: () => [],
    },
    permissionsList: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isActive() {
      return this.features.some((feature) => this.permissionsList[feature]);
    },
  },
};
</script>
<style lang="scss" scoped>
.RoleFeatureGroup {
  padding-bottom: 0.75em;

  h6 {
    font-size: 1rem;
    font-weight: 500;
    margin: 0 0 0.25em;
  }
  &.not-active h6 {
    color: #9ca3af;
  }
  .list {
    padding-left: 0.125em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/role/featureGroup.vue